var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "footer" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm.introduction
          ? _c("div", { staticClass: "col-md-5 col-sm-10" }, [
              _c("h4", [_vm._v("简介")]),
              _vm._v(" "),
              _c("small", { staticClass: "color-eee" }, [
                _vm._v(_vm._s(_vm.introduction)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5 col-sm-7" }, [
          _c("h4", [_vm._v("合作")]),
          _vm._v(" "),
          _c("p", { staticClass: "color-eee" }, [
            _vm._v("\n                    电话：" + _vm._s(_vm.phone) + " "),
            _c("br"),
            _vm._v(" "),
            _vm.mailbox
              ? _c("small", [_vm._v("合作咨询邮箱：" + _vm._s(_vm.mailbox))])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.address
            ? _c("small", { staticClass: "color-eee" }, [
                _vm._v(
                  "\n                    地址：" +
                    _vm._s(_vm.address) +
                    "\n                "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 col-sm-7" }, [
          _vm.erweima
            ? _c("img", {
                staticClass: "img-responsive footer-logo",
                attrs: { src: _vm.erweima, alt: "logo" },
              })
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "copyrights" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 text-center" }, [
            _vm._v(
              "\n                    ©" +
                _vm._s(
                  _vm.realmNameRegNum
                    ? _vm.realmNameRegNum
                    : "京ICP备19022229号-1"
                ) +
                "\n                "
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 text-center foot-link" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/foot.vue?vue&type=template&id=2c872504&scoped=true&
// module id = null
// module chunks = 